import { useContext, useEffect, useRef } from 'react';
import invariant from 'invariant';
import ConditionContext from '../components/ConditionContext';
import DataPathContext from '../components/DataPathContext';
export const useClearable = (callback)=>{
    invariant(typeof callback === 'function', 'callback must be a function.');
    const ctxDataPath = useContext(DataPathContext);
    const ctxCondition = useContext(ConditionContext);
    const ref = useRef(callback);
    ref.current = callback;
    useEffect(()=>{
        const clearDataCallback = (...args)=>{
            return ref.current(...args);
        };
        if (ctxCondition) {
            ctxCondition.registerClearableComponent(ctxDataPath, clearDataCallback);
        }
        return ()=>{
            if (ctxCondition) {
                ctxCondition.unregisterClearableComponent(ctxDataPath, clearDataCallback);
            }
        };
    }, [
        ctxCondition,
        ctxDataPath
    ]);
};
